// extracted by mini-css-extract-plugin
export default {"root":"COEonBLB7fFnIwHod4oP","content":"fONKddchnrjHVs_Pi3Mu"};